import { getAuthMode } from '@app/utils'

import { getActiveAuthTokenFromCookies } from './getActiveAuthTokenFromCookies'
import { hasImpersonationAmr } from './hasImpersonationAmr'

export { getActiveAuthTokenFromCookies } from './getActiveAuthTokenFromCookies'
export { getAuthSessionKey } from './getAuthSessionKey'
export { getAuthSessionKeyFromCookies } from './getAuthSessionKeyFromCookies'
export { hasImpersonationAmr } from './hasImpersonationAmr'

export const isImpersonatedB2BSession = () => {
  const { buyerTokenMode } = getAuthMode()
  const token = getActiveAuthTokenFromCookies()

  return hasImpersonationAmr(token) || buyerTokenMode
}
